import React from "react";
import PropTypes from "prop-types";

import SearchAndBrowseCollectionGrid from "icons/SearchAndBrowseCollectionGrid";
import BrowseAllContentCTA from "./BrowseAllContentCTA";
import BrowseAllContentTextLink from "./BrowseAllContentTextLink";
import Heading from "core/Heading";

import { SearchAndLinkContainer } from "./styles";

import { BROWSE_ICON_COLLECTIONS_BY_CREATOR } from "data/links";

const IconCollectionsSection = ({ collections = [], totalCount, username }) => {
    const browseAllProps = {
        contentCount: totalCount || 0,
        contentType: "collection",
        username,
        href: BROWSE_ICON_COLLECTIONS_BY_CREATOR.replace(":username", username)
    };

    if (totalCount === 0) return null;

    return (
        <section>
            <SearchAndLinkContainer>
                <Heading size="sm">Icon Collections</Heading>
                <BrowseAllContentTextLink {...browseAllProps} />
            </SearchAndLinkContainer>
            <SearchAndBrowseCollectionGrid
                totalCount={0}
                items={collections || []}
                LoadMore={() => null}
            />
            <BrowseAllContentCTA {...browseAllProps} />
        </section>
    );
};

IconCollectionsSection.propTypes = {
    collections: PropTypes.arrayOf(PropTypes.object).isRequired,
    totalCount: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired
};

export default IconCollectionsSection;
